// socket.js
import { readFromLocalStorage } from "@/modules/consult/utils/utils";
import { io } from "socket.io-client";

const socket = io(import.meta.env.VITE_APP_URL_BASE);

interface IRegisterUserProps {
  accountId: string;
  cpf: string;
}

export const registerUser = async ({
  accountId,
  cpf,
}: IRegisterUserProps): Promise<void> => {
  const sanitizedCpf = cpf.replace(/[^a-zA-Z0-9 ]/g, "");

  let startTime = readFromLocalStorage<string>("startTime");
  if (!startTime) {
    startTime = Date.now().toString();
  }

  const emitRegister = () => {
    socket.emit("register", {
      accountId,
      cpf: sanitizedCpf,
      startTime,
    });
  };

  if (socket.connected) {
    emitRegister();
  } else {
    await new Promise<void>((resolve) => {
      socket.once("connect", () => {
        resolve();
      });
      socket.connect();
    });
    emitRegister();
  }
};

export default socket;
